
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyBarrelXShape as ObiBuoyBarrelXShapeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-barrel-x-shape.js';
 
 
 

 
 export const ObiBuoyBarrelXShape = createComponent({
   react: React,
   tagName: 'obi-buoy-barrel-x-shape',
   elementClass: ObiBuoyBarrelXShapeElement,
   events: {
     
   }
  });
 
 